/* eslint-disable no-undef */
import { createFetch } from '@vueuse/core'
import { getToken } from '@/utils/auth'

function WP (host) {
  const API_URL = host || process.env.VUE_APP_WP_API
  if (!API_URL) {
    console.error('WP_REST host not defined')
  }
  const LOGIN = 'custom/v1/user/login'
  const REGISTER = 'custom/v1/user/register'
  const TOKEN_VALIDATION = 'jwt-auth/v1/token/validate'
  const PRODUCTS = 'wc/v3/products'

  // const Authorization = `Bearer ${getToken()}`

  const Client = createFetch({
    baseUrl: API_URL
  })

  this.login = async (credentials) => {
    try {
      const { data, response } = await Client(LOGIN, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials)
      }).json()

      if (!data?.value) {
        throw new Error(response.value.status)
      }

      return data?.value?.data
    } catch (error) {
      console.error(error)
      throw new Error(error)
    }
  }

  this.register = async (credentials) => {
    try {
      const { data, response } = await Client(REGISTER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials)
      }).json()

      if (!data?.value) {
        throw new Error(response.value.status)
      }

      return data?.value?.data
    } catch (error) {
      console.error(error)
      throw new Error(error)
    }
  }

  this.validateToken = async (token) => {
    try {
      const { data, response } = await Client(TOKEN_VALIDATION, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token || getToken()}`
        }
      }).json()

      if (!data?.value) {
        throw new Error(response.value.status)
      }

      if (data.value?.code === 'jwt_auth_valid_token' && data.value?.data?.status === 200) {
        return true
      }

      return false
    } catch (error) {
      // console.error(error)
      return false
      // throw new Error(error)
    }
  }

  this.getProducts = async () => {
    try {
      const { data } = await Client(PRODUCTS, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        }
      }).json()

      return data.value
    } catch (error) {
      console.error(error)
    }
  }

  this.getVariations = async (id) => {
    try {
      const { data } = await Client(`${PRODUCTS}/${id}/variations?per_page=100`, {
        headers: {
          'Authorization': `Bearer ${getToken()}`
        }
      }).json()

      return data.value

    } catch (error) {
      console.error(error)
    }
  }

  const getProduct = async (endpoint) => {
    try {

      const { data: { value } } = await Client(`/custom/v1/${endpoint}`).json()

      return value ? value.data : null

    } catch (error) {
      console.error("[Configurator App] Error adding to cart")
      throw new Error(error)
    }
  }

  this.getProductBySlug = async (slug) => {
    return await getProduct(`get-product-by-slug/?slug=${slug}`)
  }

  this.getProductById = async (id) => {
    return await getProduct(`get-product-by-id/?id=${id}`)
  }

  this.addToCart = async (payload) => {
    try {
      const { data } = await Client('/custom/v1/add-to-cart', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        },
        body: JSON.stringify(payload)
      }).json()

      return data

    } catch (error) {
      console.error("[Configurator App] Error adding to cart")
      throw new Error(error)
    }
  }

  /**
   * Copilot: Write function description
   *
   *
   * param payload (Object)
   *  product_id (String)
   *  meta_data (Object)
   *    configuration_id (String)
   *  quantity (Number)
   */
  this.updateItemQuantity = async(payload) => {
    try {
      const { data } = await Client('/custom/v1/cart-item-quantity', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        },
        body: JSON.stringify(payload)
      }).json()

      return data

    } catch (error) {
      console.error("[Configurator App] Error updating cart quantity")
      throw new Error(error)
    }
  }

  this.getCartItems = async () => {
    try {

      const { data: { value } } = await Client(`/custom/v1/get-cart-items`, {
        headers: {
          'Authorization': `Bearer ${getToken()}`
        }
      }).json()

      return value ? value.data : null

    } catch (error) {
      console.error("[Configurator App] Error getting cart items")
      throw new Error(error)
    }
  }

  this.getCartItem = async (id) => {
    try {
      const cartItems = await this.getCartItems()

      if (!cartItems) {
        return null
      }

      const item = cartItems.find((item) => item?.meta_data?.configuration_id === id)

      return item ? item : null

    } catch (error) {
      console.error("[Configurator App] Error getting cart item")
      throw new Error(error)
    }
  }

  this.getPricingForProduct = async (slug) => {
    try {
      const { data: { value } } = await Client(`/custom/v1/utils/quantity-pricing/${slug}`).json()

      return value ? value.data : null

    } catch (error) {
      console.error("[Configurator App] Error getting pricing for product")
      throw new Error(error)
    }
  }

}

export default WP
